import {BaseModel} from "../../../../../infrastructure/models/base-model";
import {computed, makeObservable, observable} from "mobx";
import type {LanguageViewModel} from "../../../../../domain/locale/models/language/language.view-model";
import {DEFAULT_CULTURE_NAME} from "../../../../../core/app/consts";
import {FOOTER_MODULE} from "../footer-module.consts";
import {ROUTE_NAMES} from "../../../../../core/consts";
import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";

export class FooterModuleDynamicLinkModel extends BaseModel {
  url: String;
  urlType: String;
  anchorText: String;
  @observable includeLanguages: Array<Number>;
  @observable excludeLanguages: Array<Number>;
  @observable includeCountries: Array<Number>;
  @observable excludeCountries: Array<Number>;
  @observable includeSportTypes: Array<Number>;
  @observable excludeSportTypes: Array<Number>;
  myScoresVisible: Boolean;
  isNoFollowLink: Boolean;
  @observable language: LanguageViewModel;
  @observable sportTypeId: Number
  @observable userCountryId: Number
  @observable currentLinkModel: BaseLinkModel;
  label: String;
  displayType: String;
  isDynamicLink: Boolean;

  constructor(
    model: FooterModuleDynamicLinkModel,
    language: LanguageViewModel,
    sportTypeId: Number,
    userCountryId: Number,
    currentLinkModel: BaseLinkModel,
    label: String
  ) {
    super();

    this.isDynamicLink = true;
    this.language = language;
    this.sportTypeId = sportTypeId;
    this.userCountryId = userCountryId;
    this.currentLinkModel = currentLinkModel;
    this.label = label;
    this.url = model.url;
    this.urlType = model.urlType;
    this.anchorText = model.anchorText;
    this.displayType = model.displayType;
    this.includeLanguages = model.includeLanguages ? Object.values(model.includeLanguages) : [];
    this.excludeLanguages = model.excludeLanguages ? Object.values(model.excludeLanguages) : [];
    this.includeCountries = model.includeCountries ? Object.values(model.includeCountries) : [];
    this.excludeCountries = model.excludeCountries ? Object.values(model.excludeCountries) : [];
    this.includeSportTypes = model.includeSportTypes ? Object.values(model.includeSportTypes) : [];
    this.excludeSportTypes = model.excludeSportTypes ? Object.values(model.excludeSportTypes) : [];
    this.myScoresVisible = model.myScoresVisible;
    this.isNoFollowLink = model.isNoFollowLink;

    makeObservable(this)
  }

  @computed get visible() {
    const languageVisibility: Boolean = this.checkValidParams(this.includeLanguages, this.excludeLanguages, this.language.id);
    const sportTypesVisibility: Boolean = this.checkValidParams(this.includeSportTypes, this.excludeSportTypes, this.sportTypeId);
    const countriesVisibility: Boolean = this.checkValidParams(this.includeCountries, this.excludeCountries, this.userCountryId);
    const scoresVisibility: Boolean = this.currentLinkModel?.name === ROUTE_NAMES.myScoresPage ? this.myScoresVisible : sportTypesVisibility;

    return languageVisibility && countriesVisibility && scoresVisibility;
  }

  checkValidParams(includesArray: Array<Number>, excludesArray: Array<Number>, id: Number) {
    const isInclude: Boolean = includesArray?.includes(id);
    const isExclude: Boolean = excludesArray?.includes(id);

    let isValid: Boolean = true;

    if(includesArray?.length > 0) {
      isValid = isInclude;
    } else if(excludesArray?.length > 0) {
      isValid = !isExclude;
    }

    return isValid;
  }

  @computed get urlLink() {
    const displayLanguageParam: String = this.language.cultureName === DEFAULT_CULTURE_NAME ? '' : '/' + this.language.displayName;
    const link: String = this.isInternal ? `${this.websiteMainUrl}${displayLanguageParam}${this.url}` : this.url;

    return link;
  }

  get websiteMainUrl() {
    return `${window.location.protocol}//${window.location.host}`
  }

  get isInternal() {
    return this.urlType === FOOTER_MODULE.DYNAMIC_LINKS.URL_TYPE.internal;
  }

  get isExternal() {
    return this.urlType === FOOTER_MODULE.DYNAMIC_LINKS.URL_TYPE.external;
  }

  get forceFollow (){
    return !this.isNoFollowLink
  }

  get isBettingZoneLink() {
    return this.displayType === FOOTER_MODULE.DYNAMIC_LINKS_DISPLAY_TYPE.bettingZone
  }

  get isScoresLink() {
    return this.displayType === FOOTER_MODULE.DYNAMIC_LINKS_DISPLAY_TYPE.scores
  }
}
